import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../image/add.svg'


const _hoisted_1 = { class: "role-container" }
const _hoisted_2 = { class: "role-list" }
const _hoisted_3 = { class: "role-card-header" }
const _hoisted_4 = { class: "role-name" }
const _hoisted_5 = { class: "role-card-media" }
const _hoisted_6 = { class: "role-card-footer" }
const _hoisted_7 = { class: "role_add" }
const _hoisted_8 = { class: "role_add_left" }
const _hoisted_9 = { class: "upload-section" }
const _hoisted_10 = { class: "uploader-wrapper" }
const _hoisted_11 = { class: "form-section" }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = { class: "form-row" }
const _hoisted_14 = { class: "role_add_right" }
const _hoisted_15 = { class: "phone-mockup" }
const _hoisted_16 = { class: "phone-screen" }
const _hoisted_17 = { class: "phone-media" }
const _hoisted_18 = {
  key: 1,
  class: "media-placeholder"
}
const _hoisted_19 = { class: "phone-info" }
const _hoisted_20 = { class: "info-item highlight" }
const _hoisted_21 = { class: "val" }
const _hoisted_22 = { class: "info-grid" }
const _hoisted_23 = { class: "info-item" }
const _hoisted_24 = { class: "val" }
const _hoisted_25 = { class: "info-item" }
const _hoisted_26 = { class: "val" }
const _hoisted_27 = { class: "info-item" }
const _hoisted_28 = { class: "val" }
const _hoisted_29 = { class: "info-item scrollable-text" }
const _hoisted_30 = { class: "val desc-text" }
const _hoisted_31 = { class: "info-item scrollable-text" }
const _hoisted_32 = { class: "val desc-text" }
const _hoisted_33 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_image = _resolveComponent("el-image")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_popconfirm = _resolveComponent("el-popconfirm")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[25] || (_cache[25] = _createElementVNode("div", { class: "zhanwei4" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.roles, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "role-card",
            key: index
          }, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.roleName), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_el_image, {
                src: item.roleImg,
                fit: "cover",
                class: "role-image"
              }, null, 8, ["src"])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_el_button, {
                type: "primary",
                plain: "",
                size: "default",
                onClick: ($event: any) => {
              $options.editRole(index);
              $data.isUpdate = true;
            }
              }, {
                default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                  _createTextVNode("编辑", -1)
                ]))]),
                _: 1
              }, 8, ["onClick"]),
              _createVNode(_component_el_popconfirm, {
                title: "确认删除该角色吗?",
                onConfirm: ($event: any) => ($options.deleteRole(index))
              }, {
                reference: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "danger",
                    plain: "",
                    size: "default"
                  }, {
                    default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                      _createTextVNode("删除", -1)
                    ]))]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["onConfirm"])
            ])
          ]))
        }), 128)),
        _createElementVNode("div", {
          class: "role-card add-role-trigger",
          onClick: _cache[0] || (_cache[0] = ($event: any) => {
          $data.customDraggingVisible = true;
          $data.form = {};
          $data.isUpdate = false;
          $data.fileList = [];
        })
        }, [...(_cache[13] || (_cache[13] = [
          _createElementVNode("div", { class: "add-icon-wrapper" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "add"
            }),
            _createElementVNode("p", null, "添加角色")
          ], -1)
        ]))])
      ])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: $data.customDraggingVisible,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.customDraggingVisible) = $event)),
      class: "custom-dragging-style",
      title: $data.isUpdate ? '编辑角色' : '建立角色',
      width: "950px",
      draggable: "",
      "destroy-on-close": "",
      "close-on-click-modal": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_el_button, {
            onClick: _cache[8] || (_cache[8] = ($event: any) => ($data.customDraggingVisible = false))
          }, {
            default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
              _createTextVNode("取消", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[9] || (_cache[9] = ($event: any) => ($data.isUpdate ? $options.updateRole() : $options.addRole()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString($data.isUpdate ? "确定修改" : "立即创建"), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "section-title" }, "角色图片", -1)),
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_el_upload, {
                  "file-list": $data.fileList,
                  "onUpdate:fileList": _cache[1] || (_cache[1] = ($event: any) => (($data.fileList) = $event)),
                  action: $options.UpdateApi,
                  "list-type": "picture-card",
                  "on-success": $options.handleAvatarSuccess,
                  "before-upload": $options.beforeAvatarUpload,
                  limit: 1
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list", "action", "on-success", "before-upload"]),
                _cache[14] || (_cache[14] = _createElementVNode("div", { class: "upload-tip" }, [
                  _createTextVNode(" 支持 JPG/PNG/GIF 格式"),
                  _createElementVNode("br"),
                  _createTextVNode("建议尺寸 1080*1920px (小于 5MB) ")
                ], -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createVNode(_component_el_form, {
                model: $data.form,
                "label-width": "auto",
                "label-position": "top",
                class: "clean-form"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_12, [
                    _createVNode(_component_el_form_item, { label: "角色名称" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $data.form.name,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($data.form.name) = $event)),
                          placeholder: "请输入角色名称",
                          maxlength: "20"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "性别" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $data.form.sex,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.form.sex) = $event)),
                          placeholder: "请输入性别",
                          maxlength: "10"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_el_form_item, { label: "年龄" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $data.form.age,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.form.age) = $event)),
                          placeholder: "请输入年龄",
                          maxlength: "10"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_form_item, { label: "职业" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: $data.form.profession,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.form.profession) = $event)),
                          placeholder: "请输入职业",
                          maxlength: "20"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode(_component_el_form_item, { label: "特殊技能" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.skill,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.form.skill) = $event)),
                        type: "textarea",
                        rows: 2,
                        placeholder: "描述角色的特殊技能...",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "角色描述" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: $data.form.desc,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.form.desc) = $event)),
                        type: "textarea",
                        rows: 2,
                        placeholder: "描述角色的性格与背景...",
                        "show-word-limit": "",
                        maxlength: "200"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  ($data.form.img)
                    ? (_openBlock(), _createBlock(_component_el_image, {
                        key: 0,
                        src: $data.form.img,
                        alt: "预览",
                        fit: "cover",
                        style: {"width":"100%","height":"100%"}
                      }, null, 8, ["src"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        }),
                        _cache[16] || (_cache[16] = _createElementVNode("span", null, "暂无角色图片", -1))
                      ]))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _cache[17] || (_cache[17] = _createElementVNode("span", { class: "label" }, "姓名:", -1)),
                    _createElementVNode("span", _hoisted_21, _toDisplayString($data.form.name || "未命名"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_22, [
                    _createElementVNode("div", _hoisted_23, [
                      _cache[18] || (_cache[18] = _createElementVNode("span", { class: "label" }, "性别:", -1)),
                      _createElementVNode("span", _hoisted_24, _toDisplayString($data.form.sex || "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_25, [
                      _cache[19] || (_cache[19] = _createElementVNode("span", { class: "label" }, "年龄:", -1)),
                      _createElementVNode("span", _hoisted_26, _toDisplayString($data.form.age || "-"), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_27, [
                    _cache[20] || (_cache[20] = _createElementVNode("span", { class: "label" }, "职业:", -1)),
                    _createElementVNode("span", _hoisted_28, _toDisplayString($data.form.profession || "-"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _cache[21] || (_cache[21] = _createElementVNode("span", { class: "label font-bold" }, "技能:", -1)),
                    _createElementVNode("span", _hoisted_30, _toDisplayString($data.form.skill || "暂无描述"), 1)
                  ]),
                  _createElementVNode("div", _hoisted_31, [
                    _cache[22] || (_cache[22] = _createElementVNode("span", { class: "label font-bold" }, "描述:", -1)),
                    _createElementVNode("span", _hoisted_32, _toDisplayString($data.form.desc || "暂无描述"), 1)
                  ])
                ]),
                _cache[23] || (_cache[23] = _createElementVNode("div", { class: "phone-action" }, [
                  _createElementVNode("div", { class: "continue-btn" }, "继续")
                ], -1))
              ])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}